import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '../../services/apiServices/security/authentication.service';
import {HttpService} from '../../services/apiServices/http-service.service';
import {TranslateService} from '@ngx-translate/core';
import {User} from '../../model/user';
import {VirtualPrinterService} from '../../services/apiServices/business/virtual-printer.service';
import {UploadVirtualPrinterComponent} from './upload/upload.component';

@Component({
  selector: 'app-virtual-printer',
  templateUrl: './virtual-printer.component.html',
  styleUrls: ['./virtual-printer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ VirtualPrinterService ]
})
export class VirtualPrinterComponent implements OnInit {
  public successMessage: string;
  public passwordInvalidMsg: string;
  public passwordConfirmInvalidMsg: string;
  public packagedVersion: string;

  @Input()
  public displayUploadVirtualPrinterPanel;
  @Output()
  public maskUploadVirtualPrinterPanel = new EventEmitter();
  public virtualPrinterFiles: any;

  public user: User;
  public virtualPrinterList: [];
  public virtualPrinterPackageList: [];

  constructor(private  authenticationService: AuthenticationService, public virtualPrinterService: VirtualPrinterService ) { }

  public ngOnInit(): void {
    this.user = this.authenticationService.getCurrentUser();

    this.updateVirtualPrinterLists();
  }

  public updateVirtualPrinterLists(): void {
    this.virtualPrinterService.getPrinterInstallerList().subscribe( response => {
      const r = response.body;
      return this.virtualPrinterList = r.datas;
    }, error => {
    });

    this.virtualPrinterService.getPrinterPackageList().subscribe( response => {
      const r = response.body;
      return this.virtualPrinterPackageList = r.datas;
    }, error => {
    });
  }
}
